import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'
import { Response } from '../../../services/api/types'
import { Order } from '../types'

const loadOrderPayments = (id?: string): Response<Order> => {
  const page = 1
  const limit = 100

  return axios.get(`/orders/${id}/payments`, {
    params: {
      page,
      limit,
      search: ''
    }
  })
}

export function useLoadOrderPayments(id?: string) {
  return useQuery(['orderPayments', id], () => loadOrderPayments(id), {
    enabled: !!id,
    onError: () =>
      toast.error('Não foi possível carregar os lançamentos!', {
        toastId: 'orderPayments'
      })
  })
}
